export default [
  {
    path: "/admin",
    name: "admin",
    component: () => import("./index.vue"),
    meta: {
      requiresRole: ["admin"],
      pageTitle: "ADMIN",
      headerColor: "amber",
      linkKey: "admin.nav.adminHome",
      type: "system",
    },
  },
  {
    path: "/admin/users",
    name: "adminusers",
    component: () => import("./admin-users.vue"),
    meta: {
      requiresRole: ["admin"],
      pageTitle: "ADMIN User management",
      headerColor: "amber",
      linkKey: "admin.nav.userManagement",
      type: "system",
    },
  },
  {
    path: "/admin/customers",
    name: "admincustomers",
    component: () => import("./admin-customers.vue"),
    meta: {
      requiresRole: ["admin"],
      pageTitle: "ADMIN Customer management",
      headerColor: "amber",
      linkKey: "admin.nav.customerManagement",
      type: "system",
    },
  },
  {
    path: "/admin/qtimes",
    name: "adminqtimes",
    component: () => import("./admin-qtimes.vue"),
    meta: {
      requiresRole: ["admin"],
      pageTitle: "ADMIN QUestion Time management",
      headerColor: "amber",
      linkKey: "admin.nav.qTimes",
      type: "system",
    },
  },
];
